/**
 * CardAsync Action Creators
 */
import { Kushki } from "@kushki/js";
import { ErrorResponse } from "@kushki/js/lib/types/error_response";
import { SubscriptionCardAsyncTokenRequest } from "@kushki/js/lib/types/subscription_card_async_token_request";
import { SubscriptionCardAsyncTokenResponse } from "@kushki/js/lib/types/subscription_card_async_token_response";
import { setErrorMessage } from "components/Error/store/Actions";
import {
  hideOverlay,
  showOverlay,
} from "components/OverLay/store/ActionCreators";
import { Actions } from "containers/CardSubscriptionAsync/store/Actions";
import { defaultTo, get } from "lodash";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { updateDisableButton } from "root/store/Reducer";
import { ICardSubscriptionAsyncActionCreator } from "types/card_subscription_action_creator";
import { ICardSubscriptionAsyncFormProps } from "types/card_subscription_async_form_props";

function getStatusValidity(state: ICardSubscriptionAsyncFormProps): boolean {
  let isValid: boolean = true;

  const inputs: string[] = ["emailInput", "cardNumber"];

  for (const inputName of inputs) isValid = state[inputName].valid && isValid;

  return isValid;
}

const inputAction: (
  payload: IInputProps
) => ICardSubscriptionAsyncActionCreator = (
  payload: IInputProps
): ICardSubscriptionAsyncActionCreator => ({
  type: Actions.UPDATE_CARD_SUBSCRIPTION_ASYNC_INPUT,
  input: payload,
});

const disableCardSubscriptionAsyncAction: () => ICardSubscriptionAsyncActionCreator = (): ICardSubscriptionAsyncActionCreator => ({
  type: Actions.DISABLE_CARD_SUBSCRIPTION_ASYNC_FORM,
});

const changeStatus: () => ICardSubscriptionAsyncActionCreator = (): ICardSubscriptionAsyncActionCreator => ({
  type: Actions.SWITCH_CARD_SUBSCRIPTION_ASYNC_VALIDITY,
});

const setDirty: (
  payload: IInputProps
) => ICardSubscriptionAsyncActionCreator = (
  payload: IInputProps
): ICardSubscriptionAsyncActionCreator => ({
  type: Actions.SET_CARD_SUBSCRIPTION_ASYNC_INPUT_DIRTY,
  input: payload,
});

const updateCardSubscriptionAsyncToken: (
  payload: string
) => ICardSubscriptionAsyncActionCreator = (
  payload: string
): ICardSubscriptionAsyncActionCreator => ({
  type: Actions.SET_CARD_SUBSCRIPTION_ASYNC_TOKEN,
  token: payload,
});

function updateInput(
  payload: IInputProps
): ThunkAction<
  void,
  CajitaStore,
  undefined,
  ICardSubscriptionAsyncActionCreator
> {
  return (
    dispatch: ThunkDispatch<
      CajitaStore,
      undefined,
      ICardSubscriptionAsyncActionCreator
    >,
    getState: () => CajitaStore
  ): void => {
    dispatch(inputAction(payload));
    const state: ICardSubscriptionAsyncFormProps = getState()
      .card_subscription_async;
    const status: boolean = getStatusValidity(state);

    if (state.isValid !== status) dispatch(changeStatus());
  };
}

function getCardSubscriptionAsyncToken(
  body: SubscriptionCardAsyncTokenRequest
): ThunkAction<
  void,
  CajitaStore,
  undefined,
  ICardSubscriptionAsyncActionCreator
> {
  return (dispatch: Function, getState: () => CajitaStore): void => {
    const kushki: Kushki = getState().config.kushkiJS as Kushki;

    dispatch(updateDisableButton(true));
    dispatch(showOverlay());
    kushki.requestSubscriptionCardAsyncToken(
      body,
      (response: SubscriptionCardAsyncTokenResponse | ErrorResponse) => {
        if ("token" in response)
          dispatch(updateCardSubscriptionAsyncToken(response.token));
        else {
          dispatch(
            setErrorMessage(defaultTo(get(response, "message", ""), ""))
          );
          dispatch(hideOverlay());
        }
        dispatch(updateDisableButton(false));

        return;
      }
    );
  };
}

export {
  setDirty,
  updateInput,
  getCardSubscriptionAsyncToken,
  changeStatus,
  disableCardSubscriptionAsyncAction,
};



// WEBPACK FOOTER //
// ./src/containers/CardSubscriptionAsync/store/ActionCreators.tsx